<template>
  <div class="my-32">
    <div class="container">
      <div class="row">
        <h1
          class="title-head text-[#000] text-center font-semibold [word-spacing:16.4px] text-[60px] uppercase"
        >
          Our Metrics Tell <br />
          the Story
        </h1>

        <!-- count-on-scorll -->
        <div
          class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 mt-28 gap-8"
        >
          <div
            class="count-card border-b-4 transition border-b-[#FFF000] bg-white text-center shadow-md px-3 py-10"
          >
            <h4
              class="text-[#000] [box-shadow: 34.854px 29.626px 48.34px 0px rgba(51, 102, 255, 0.05)] font-bold text-[41px]"
            >
              10k+
            </h4>
            <h4 class="text-[#000]">Total Coaches</h4>
          </div>
          <div
            class="count-card border-b-4 transition border-b-[#FFF000] bg-white text-center shadow-md px-3 py-10"
          >
            <h4
              class="text-[#000] [box-shadow: 34.854px 29.626px 48.34px 0px rgba(51, 102, 255, 0.05)] font-bold text-[41px]"
            >
              931k+
            </h4>
            <h4 class="text-[#000]">Total Clients</h4>
          </div>
          <div
            class="count-card border-b-4 transition border-b-[#FFF000] bg-white text-center shadow-md px-3 py-10"
          >
            <h4
              class="text-[#000] [box-shadow: 34.854px 29.626px 48.34px 0px rgba(51, 102, 255, 0.05)] font-bold text-[41px]"
            >
              240k+
            </h4>
            <h4 class="text-[#000]">Workouts Delivered</h4>
          </div>
          <div
            class="count-card border-b-4 transition border-b-[#FFF000] bg-white text-center shadow-md px-3 py-10"
          >
            <h4
              class="text-[#000] [box-shadow: 34.854px 29.626px 48.34px 0px rgba(51, 102, 255, 0.05)] font-bold text-[41px]"
            >
              12k+
            </h4>
            <h4 class="text-[#000]">Diets Delivered</h4>
          </div>
        </div>
        <!-- end -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Our-Metrics",
};
</script>
<style lang="scss">
@import "~/public/styles/ourMetrics/index.scss";
</style>
